import React from "react";

const ecosystemHighlights = [
  "Expert-led, structured learning paths",
  "Personalized 1:1 mentorship and career coaching",
  "Access to a robust alumni and direct corporate hiring network (220+ MNCs)",
];

const MIlesCpaCoaching = () => {
  return (
    <section className="w-full bg-[#F6F6F6] md:py-12">
      <div className="main_container">
        <div className="max-md:bg-white max-md:rounded-2xl max-md:shadow-[0_0_30px_0_rgba(0,0,0,0.10)] max-md:px-4 max-md:py-5">
          <h2 className="text-xl md:text-3xl font-bold tracking-[-1.28px] text-left md:text-center">
            <span className="text-[#39F]">Miles CPA: </span>
            <span className="text-[#061A2F]">
              Not Just Coaching, But an Ecosystem
            </span>
          </h2>

          <p className="text-[#333] text-sm mt-4 md:mt-7 text-left md:text-center max-w-[900px] mx-auto">
            We know that becoming a CPA is not just about passing a test; it's
            about launching a globally recognized career, advancing your
            professional capabilities, and becoming part of an elite network of
            accounting professionals.
          </p>
          <p className="text-[#333] text-sm mt-4 text-left md:text-center max-w-[900px] mx-auto">
            At Miles, we redefine what it means to be a CPA and its preparation
            by delivering a complete ecosystem for career growth, not just a
            coaching program. Miles Education CPA is designed to take you from
            exam readiness to global employability, with:
          </p>

          <div className="mt-8 flex flex-col md:flex-row gap-3 md:gap-6 max-w-[900px] mx-auto">
            {ecosystemHighlights.map((text) => (
              <div
                key={text}
                className="bg-[#F5F5F5] md:bg-white border-l-4 border-[#2A85FF] md:flex-1 p-4 flex items-center"
              >
                <p className="text-[#0C2036] text-sm">{text}</p>
              </div>
            ))}
          </div>

          <p className="text-[#333] text-sm mt-8 text-left md:text-center max-w-[900px] mx-auto">
            And we don’t stop at exam success. With career support, placement
            assistance, and lifelong access to learning resources, your
            experience with Miles Education CPA ensures you’re future-ready, in
            addition to being CPA-ready.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MIlesCpaCoaching;
